import React from 'react'
import styled from 'styled-components'

import VideoMeetingsLogo from '~/components/icons/meet-logo'
import { translate } from '~/core/translate'

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  position: relative;
  text-align: center;
  top: -8%;
  width: 100%;
`

const Big = styled.div`
  margin: 24px auto;
`

const Line1 = styled.div`
  color: #1c2025;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
`

const Line2 = styled.div`
  color: #5e6d7a;
  font-weight: 600;
  font-size: 19px;
  line-height: 28px;
  margin-top: 4px;
`

const Small = styled.div`
  color: #000;
  font-size: 15px;
  line-height: 24px;;
  max-width: 360px
`

const NoPermission = () => (
  <Container>
    <VideoMeetingsLogo size={44} />
    <Big>
      <Line1>{translate('get_more_of_meetings')}</Line1>
      <Line2>{translate('upgrade_to_video_meetings')}</Line2>
    </Big>
    <Small>{translate('ask_admin_to_upgrade2')}</Small>
  </Container>
)

export default NoPermission
